export const REFRESH_TOKEN_KEY = 'token';
export const ACCESS_TOKEN_KEY = 'accessToken';
export const USER_KEY = 'user';
